import { render } from "./DetailsArea.vue?vue&type=template&id=8c54c336"
import script from "./DetailsArea.vue?vue&type=script&lang=js"
export * from "./DetailsArea.vue?vue&type=script&lang=js"

import exportComponent from "/Users/remy/Sites/baghera/woc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__